import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { MenuIcon, XIcon, SnowflakeIcon } from 'lucide-react';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-navy/70 backdrop-blur-xl border-b border-white/10 py-3' : 'bg-transparent py-5'}`} data-id="element-80">
      <div className="container mx-auto px-6 max-w-7xl flex items-center justify-between" data-id="element-81">
        <div className="flex items-center gap-2 text-frost font-bold text-xl tracking-tight" data-id="element-82">
          <SnowflakeIcon className="w-6 h-6 text-ice" data-id="element-83" />
          <span data-id="element-84">Citadelgames</span>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-85">
          <a href="#platform" className="text-sm font-medium text-white/70 hover:text-ice transition-colors" data-id="element-86">
            Platform
          </a>
          <a href="#solutions" className="text-sm font-medium text-white/70 hover:text-ice transition-colors" data-id="element-87">
            Solutions
          </a>
          <a href="#pricing" className="text-sm font-medium text-white/70 hover:text-ice transition-colors" data-id="element-88">
            Pricing
          </a>
          <a href="#about" className="text-sm font-medium text-white/70 hover:text-ice transition-colors" data-id="element-89">
            About
          </a>
        </nav>

        <div className="hidden md:flex items-center gap-4" data-id="element-90">
          <button className="text-sm font-medium text-white hover:text-ice transition-colors" data-id="element-91">
            Log In
          </button>
          <button className="bg-ice hover:bg-ice-light text-navy font-semibold text-sm px-5 py-2.5 rounded-full transition-all shadow-[0_0_15px_rgba(77,168,218,0.3)] hover:shadow-[0_0_25px_rgba(77,168,218,0.5)]" data-id="element-92">
            Start Free Trial
          </button>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-white/80 hover:text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-93">
          {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-94" /> : <MenuIcon className="w-6 h-6" data-id="element-95" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="md:hidden absolute top-full left-0 right-0 bg-navy-light/95 backdrop-blur-xl border-b border-white/10 p-6 flex flex-col gap-4 shadow-2xl" data-id="element-96">
          <a href="#platform" className="text-base font-medium text-white/80 hover:text-ice" onClick={() => setMobileMenuOpen(false)} data-id="element-97">
            Platform
          </a>
          <a href="#solutions" className="text-base font-medium text-white/80 hover:text-ice" onClick={() => setMobileMenuOpen(false)} data-id="element-98">
            Solutions
          </a>
          <a href="#pricing" className="text-base font-medium text-white/80 hover:text-ice" onClick={() => setMobileMenuOpen(false)} data-id="element-99">
            Pricing
          </a>
          <a href="#about" className="text-base font-medium text-white/80 hover:text-ice" onClick={() => setMobileMenuOpen(false)} data-id="element-100">
            About
          </a>
          <div className="h-px bg-white/10 my-2" data-id="element-101" />
          <button className="w-full text-left text-base font-medium text-white/80 hover:text-ice" data-id="element-102">
            Log In
          </button>
          <button className="w-full bg-ice text-navy font-semibold text-base px-5 py-3 rounded-lg mt-2" data-id="element-103">
            Start Free Trial
          </button>
        </motion.div>}
    </header>;
}